import { render } from "./ProposalSubmissionPage.vue?vue&type=template&id=a714b902&scoped=true"
import script from "./ProposalSubmissionPage.vue?vue&type=script&lang=js"
export * from "./ProposalSubmissionPage.vue?vue&type=script&lang=js"

import "./ProposalSubmissionPage.vue?vue&type=style&index=0&id=a714b902&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a714b902"]])

export default __exports__